import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './manageproject.css';
import HttpClient from '../utils/HttpClient';

const ManageProjectForm = () => {
    const initial = {
        name: "",
        itemID: []
    }
    const navigate = useNavigate();
    const location = useLocation();
    const [projectName, setProjectName] = useState(initial);
    const [itemIDs, setItemIDs] = useState([]);
    const isEdit = location.state ? true : false;
    const [allItemsList, setAllItemsList] = useState([]);
    const [itemNameToIdMap, setItemNameToIdMap] = useState([])
    console.log("df65g4d51", location?.state)

    // >>>>Fetch All Items Data<<<<
    const fetchAllItems = async () => {
        const res = await HttpClient.requestData("project-item", "GET");
        if (res && res.status) {
            const items = res.data;
            setAllItemsList(items);

            // Create a map of item names to IDs
            const nameToIdMap = items.reduce((acc, item) => {
                acc[item.itemName] = item._id;
                return acc;
            }, {});
            setItemNameToIdMap(nameToIdMap);
        } else {
            toast.error("Failed to fetch item data.");
        }
    };

    useEffect(() => {
        if (location.state) {
            const { projectName, itemName } = location.state;
            // Convert comma-separated itemName string to array of IDs
            const itemNamesArray = itemName.split(',').map(name => name.trim());
            const itemIDsArray = itemNamesArray.map(name => itemNameToIdMap[name]).filter(id => id); // Filter out any undefined values

            setProjectName({
                name: projectName || "",
                itemID: itemIDsArray
            });
        }
    }, [location.state, itemNameToIdMap]);

    // useEffect(() => {
    //     if (location.state) {
    //         const { projectName, itemName } = location.state;
    //         // Convert comma-separated itemName string to array of IDs
    //         const itemNamesArray = itemName.split(',').map(name => name.trim());
    //         const itemIDsArray = itemNamesArray.map(name => itemNameToIdMap[name]).filter(id => id); // Filter out any undefined values

    //         setProjectName({
    //             name: projectName || "",
    //             itemID: itemIDsArray
    //         });
    //     }
    // }, [location.state, itemNameToIdMap]);

    // useEffect(() => {
    //   const projectNames = {
    //     "668d8a2ccd16a938a1dbc97d": "Land",
    //     "668d8a32cd16a938a1dbc981": "WBS Level Dashboard",
    //     "668d8a32cd16a938a1dbc982": "Quantity Progress",
    //     "668d8a32cd16a938a1dbc983": "Critical Activity",
    //     "668d8a32cd16a938a1dbc984": "Issues",
    //     "668d8a32cd16a938a1dbc985": "Risks",
    //     "668d8a32cd16a938a1dbc986": "EHS Statistics",
    //     "668d8a32cd16a938a1dbc987": "Material stock at site for steel",
    //     "668d8a32cd16a938a1dbc988": "S-curve",
    //     "668d8a32cd16a938a1dbc989": "Critical path length"
    //   };
    //   const selectedNames = itemIDs.map(id => projectNames[id]).join(", ");
    //   setProjectName(selectedNames);
    // }, [itemIDs]);

    const handleBackClick = () => {
        navigate(-1); // Navigate to the previous page in the history
    };

    // const handleSaveClick = async (event) => {
    //     event.preventDefault();
    //     const { name, itemID } = projectName;
    //     if (!name.trim()) {
    //         return toast.error('Please enter project name...!');
    //     }

    //     if (!itemID || itemID.length === 0) {
    //         return toast.error("Please select minimum one item...!")
    //     }

    //     const data = {
    //         projectName: name,
    //         itemID: itemID
    //     };
    //     console.log("d5f2g561d", data)
    //     // return
    //     try {
    //         if (isEdit) {
    //             // Edit existing project
    //             const res = await HttpClient.requestData(`project/${location.state.id}`, 'PUT', data);
    //             if (res && res.status) {
    //                 navigate('/manageproject');
    //                 sessionStorage.setItem('toastMessage', 'Project updated successfully.');
    //             } else {
    //                 sessionStorage.setItem('toastMessage', 'Failed to update project. Please try again.');
    //             }
    //         } else {
    //             // Add new project
    //             const res = await HttpClient.requestData('project', 'POST', data);
    //             if (res && res.status) {
    //                 navigate('/manageproject');
    //                 sessionStorage.setItem('toastMessage', 'Project added successfully.');
    //             } else {
    //                 sessionStorage.setItem('toastMessage', 'Failed to add project. Please try again.');
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error saving project:', error);
    //         sessionStorage.setItem('toastMessage', 'Failed to save project. Please try again.');
    //         // navigate('/manageproject');
    //     }
    // };

    const handleSaveClick = async (event) => {
        event.preventDefault();
        const { name, itemID } = projectName;
        if (!name.trim()) {
            return toast.error('Please enter project name...!');
        }

        if (!itemID || itemID.length === 0) {
            return toast.error("Please select at least one item...!");
        }

        const data = {
            projectName: name,
            itemID: itemID
        };
        console.log("d5f2g561d", data);

        try {
            if (isEdit) {
                // Edit existing project
                const res = await HttpClient.requestData(`project/${location.state.id}`, 'PUT', data);
                if (res && res.status) {
                    navigate('/manageproject');
                    sessionStorage.setItem('toastMessage', 'Project updated successfully.');
                } else {
                    sessionStorage.setItem('toastMessage', 'Failed to update project. Please try again.');
                }
            } else {
                // Add new project
                const res = await HttpClient.requestData('project', 'POST', data);
                if (res && res.status) {
                    navigate('/manageproject');
                    sessionStorage.setItem('toastMessage', 'Project added successfully.');
                } else {
                    sessionStorage.setItem('toastMessage', 'Failed to add project. Please try again.');
                }
            }
        } catch (error) {
            console.error('Error saving project:', error);
            sessionStorage.setItem('toastMessage', 'Failed to save project. Please try again.');
        }
    }

    // const handleCheckboxChange = (e) => {
    //   const id = e.target.value;
    //   if (e.target.checked) {
    //     setItemIDs([...itemIDs, id]);
    //   } else {
    //     setItemIDs(itemIDs.filter(itemID => itemID !== id));
    //   }
    // };

    // const projectNames = [
    //   { id: "668d8a2ccd16a938a1dbc97d", name: "Land" },
    //   { id: "668d8a32cd16a938a1dbc981", name: "WBS Level Dashboard" },
    //   { id: "668d8a32cd16a938a1dbc982", name: "Quantity Progress" },
    //   { id: "668d8a32cd16a938a1dbc983", name: "Critical Activity" },
    //   { id: "668d8a32cd16a938a1dbc984", name: "Issues" },
    //   { id: "668d8a32cd16a938a1dbc985", name: "Risks" },
    //   { id: "668d8a32cd16a938a1dbc986", name: "EHS Statistics" },
    //   { id: "668d8a32cd16a938a1dbc987", name: "Material stock at site for steel" },
    //   { id: "668d8a32cd16a938a1dbc988", name: "S-curve" },
    //   { id: "668d8a32cd16a938a1dbc989", name: "Critical path length" }
    // ];

    // const handleCheckboxChange = (e) => {
    //     const id = e.target.value;
    //     const isChecked = e.target.checked;
    //     setProjectName(prevState => ({
    //         ...prevState,
    //         itemID: isChecked
    //             ? [...prevState.itemID, id]
    //             : prevState.itemID.filter(itemID => itemID !== id)
    //     }));
    // };

    const handleCheckboxChange = (e) => {
        const id = e.target.value;
        const isChecked = e.target.checked;
        setProjectName(prevState => ({
            ...prevState,
            itemID: isChecked
                ? [...prevState.itemID, id]
                : prevState.itemID.filter(itemID => itemID !== id)
        }));
    };

    useEffect(() => {
        fetchAllItems()
    }, [])
    return (
        <div className='projectFormContainer'>
            <div className='header'>
                <b style={{ fontSize: "20px", fontWeight: "400" }}>
                    {isEdit ? 'Edit Project' : 'Add Project'}
                </b>
                <b className='back'
                    onClick={handleBackClick}
                    style={{ color: "rgb(208, 38, 38)" }}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px' }}></i>
                    Back
                </b>
            </div>
            <form className='projectForm' onSubmit={handleSaveClick}>
                <div className='formGroup'>
                    <label htmlFor="projectName">Project Name</label><br />
                    <input
                        type="text"
                        id="name"
                        placeholder="Project Name"
                        name='name'
                        value={projectName?.name}
                        onChange={(e) => setProjectName({ ...projectName, name: e.target.value })}
                    />
                </div>

                <div className='formGroup p-3' style={{ border: "1px solid #000", height: "350px", overflow: "auto" }}>
                    {allItemsList.map((project) => (
                        <label key={project._id}>
                            <input
                                type="checkbox"
                                name='itemID'
                                value={project._id}
                                onChange={handleCheckboxChange}
                                checked={projectName.itemID.includes(project._id)}
                            /> {project.itemName}
                        </label>
                    ))}
                </div>

                <button type="submit" className='saveButton' style={{ backgroundColor: "rgb(208, 38, 38)" }}>
                    {isEdit ? 'Edit' : 'Save'}
                </button>
            </form>
            <div className="footer" style={{ position: "fixed", bottom: "0", width: "100%", padding: "10px 0", zIndex: "-99" }}>
                <p style={{ fontSize: "12px", color: "#666", margin: "0" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </div>

            <ToastContainer />
        </div>
    );
};

export default ManageProjectForm;
